import { ChristmasBanner, ChristmasBannerOptions } from 'PARTIALS/christmas/banner';
import { cookie } from 'LIBRARY/cookie';
import 'PARTIALS/christmas/landing';


export class Christmas {
    private banners: ChristmasBannerConfig[] = [];

    constructor(banners?: ChristmasBannerConfig[]) {
        if (banners) {
            this.banners = banners;
            this.print();
        }
    }

    public addBanner(config: ChristmasBannerConfig) {
        this.banners.push(config);
    }

    public print() {
        const date = new Date();
        const banner = this.banners.reduce((acc: ChristmasBannerConfig | null, banner) => {
            if (date >= banner.dateStart && date <= banner.dateEnd || cookie.getItem('christmas') === 'debug') acc = banner;
            return acc;
        }, null);
        if (banner) {
            const christmasBanner = new ChristmasBanner(banner.options);
            const christmasBannerCookie = cookie.getItem(`christmas-banner-week${banner.options.week}`);
            christmasBanner.addEventListener('banner:hide', () =>
                cookie.setItem(`christmas-banner-week${banner.options.week}`, '1', { expires: new Date(date.getTime() + 60 * 60 * 1000) }),
            );
            if (!christmasBannerCookie && window.innerWidth >= 768) {
                christmasBanner.toggle();
            }
        }
    }
}

export type ChristmasProjects = 'freepik' | 'flaticon' | 'freepikcompany';

export interface ChristmasBannerConfig {
    dateStart: Date;
    dateEnd: Date;
    showPremium?: boolean;
    options: ChristmasBannerOptions;
}
